import { isNumber } from 'lodash';
import { ACTIVE, INACTIVE } from '../../../../../constants/components/pages/challenges/statuses';

export const useChallengeSubQuests = (subQuests) => {
  return (subQuests ?? []).reduce((acc, subQuest) => {
    const { previousQuestId } = subQuest;

    const questState =
      !isNumber(previousQuestId) || subQuests?.some?.(({ qid, isCollected }) => qid === previousQuestId && isCollected)
        ? ACTIVE
        : INACTIVE;

    const isLocked = !acc.some(({ isLocked }) => isLocked) && questState === INACTIVE;

    acc.push({ ...subQuest, questState, isLocked });

    return acc;
  }, []);
};
